var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('Adm',{attrs:{"videcam":_vm.videcam},on:{"on-watch":_vm.onWatch}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }